import React, { Component, Suspense } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch, withRouter } from 'react-router-dom';
import * as router from 'react-router-dom';
import {Container}  from 'react-bootstrap';
import routes from '../../routes';
import Loading from '../../views/Pages/Loading';
import {Navbar, Nav, Col, Row}  from 'react-bootstrap';
import libertyLogo from '../../assets/images/logo_liberty.svg';
import './DefaultLayout.scss';

const AppHeader = React.lazy(() => import('./AppHeader/AppHeader'));
const AppFooter = React.lazy(() => import('./AppFooter/AppFooter'));

class DefaultLayout extends Component {

  constructor(props) {
    super(props);
  }

  componentDidUpdate(prevProps, prevState) {
        if (this.props.error && !prevProps.error) {
            this.props.history.replace('/noconnection');
        }
  };

  render(){
    const currentPath = this.props.location.pathname; // Obtenemos el pathname actual
    return (
        <div className="App">
          <div className="app-body">
              <main className="main">
                  {
                    (this.props.loading) ?
                    (
                        <Container fluid className="p-0">
                            <Loading/>
                        </Container>
                    ) : null
                  }
                <Container fluid className={this.props.loading ? 'd-none': 'p-0'}>
                        <Switch>
                          {routes.map((route, idx) => {
                            return route.component ? (
                              <Route
                                key={idx}
                                path={route.path}
                                exact={route.exact}
                                name={route.name}
                                render={props => (
                                  <route.component {...props} />
                                )} />
                            ) : (null);
                          })}
                        </Switch>
                  </Container>
                </main>
                {currentPath === "/" ? null : <AppFooter />}

          </div>
        </div>
    );
  };

};

const mapStateToProps = state => {
    return {
        token: state.session.token,
        error: state.action.error,
        loading: state.action.loading,
    };
};


export default connect(mapStateToProps)(DefaultLayout);
